import React, { Component } from 'react';
import Utils                from '../../../Utils/Utility';
import Parse                from 'parse';

export default class Settings  extends Component {

    constructor(props) {
        super(props);
    }

    generateDataRow() {
        return this.props.locationDetails.map(
            (location) => {
                return (
                    <tr key={location.objectId}>
                        <td>{ Utils.getAddressStrFromLocation( location )}</td>
                        <td>{ location.taxes }</td>
                    </tr>
                );
            });
    }

    render() {
        return (
            <div className="section settings-pg">
                <div className="container">
                  <h2>Tax rate</h2>
                  <p>Business Locations and their tax rate</p>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Address</th>
                        <th>Tax Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                        { this.generateDataRow() }
                    </tbody>
                  </table>
                </div>
           </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/settings/settings.js